function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype), d = Object.defineProperty;
    return d(g, "next", {
        value: verb(0)
    }), d(g, "throw", {
        value: verb(1)
    }), d(g, "return", {
        value: verb(2)
    }), typeof Symbol === "function" && d(g, Symbol.iterator, {
        value: function() {
            return this;
        }
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { I18nConsumer } from '@wegic/i18n-core';
import { Button, Message } from '@wegic/ui';
import classNames from 'classnames';
import { useCallback, useRef, useState } from 'react';
import IconClose from '@/assets/icons/CloseIcon.svg?react';
import IconLeftArrow from '@/assets/icons/LeftArrow.svg?react';
import EmailVerify from '@/components/EmailVerify';
import ForgetPasswordForm from '@/components/ForgetPassword';
import LoginForm from '@/components/LoginForm';
import { isMobile } from '@/const/browser';
import { LOGIN_I18N_NAMESPACE, loginI18nLoaders } from '../../i18n/loaders';
import styles from './index.module.less';
import '@/styles/index.less';
/**
 * 认证容器组件
 * 包含登录、注册、忘记密码等表单的切换逻辑
 */ function AuthContainerContent(props) {
    var config = props.config, className = props.className;
    var _ref = config || {}, ui = _ref.ui, onEvent = _ref.onEvent;
    var _useState = _sliced_to_array(useState('login'), 2), mode = _useState[0], setMode = _useState[1];
    var _useState1 = _sliced_to_array(useState(false), 2), isVerificationLocked = _useState1[0], setIsVerificationLocked = _useState1[1];
    var verificationLockedRef = useRef(false);
    var canBack = mode !== 'login';
    var isBackDisabled = mode === 'register' && isVerificationLocked;
    var isShowHeader = canBack || (ui === null || ui === void 0 ? void 0 : ui.showClose);
    var isHedgeHeadSpacing = (ui === null || ui === void 0 ? void 0 : ui.hedgeHeadSpacing) && isShowHeader;
    var handleVerificationLockChange = useCallback(function(isLocked) {
        verificationLockedRef.current = isLocked;
        setIsVerificationLocked(isLocked);
    }, []);
    var handleBackClick = useCallback(function() {
        if (mode === 'register' && verificationLockedRef.current) {
            return;
        }
        setMode('login');
    }, [
        mode
    ]);
    var handleCloseClick = useCallback(function() {
        onEvent === null || onEvent === void 0 ? void 0 : onEvent({
            type: 'modal:close'
        });
    }, [
        onEvent
    ]);
    var wrappedConfig = _object_spread_props(_object_spread({}, config), {
        onEvent: useCallback(function(event) {
            return _async_to_generator(function() {
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (event.type === 'password:reset:success') {
                                Message.success(intl.get('Reset_Password_Success'));
                            }
                            return [
                                4,
                                onEvent === null || onEvent === void 0 ? void 0 : onEvent(event)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            })();
        }, [
            onEvent
        ])
    });
    var renderContent = function() {
        if (mode === 'login') {
            return /*#__PURE__*/ _jsx(LoginForm, {
                config: wrappedConfig,
                onForgetPassword: function() {
                    return setMode('forget');
                },
                onRegister: function() {
                    handleVerificationLockChange(false);
                    setMode('register');
                }
            });
        }
        if (mode === 'forget') {
            return /*#__PURE__*/ _jsx(ForgetPasswordForm, {
                config: wrappedConfig
            });
        }
        if (mode === 'register') {
            return /*#__PURE__*/ _jsx(EmailVerify, {
                config: wrappedConfig,
                onLockChange: handleVerificationLockChange
            });
        }
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: classNames(styles['auth-container'], className),
        style: isHedgeHeadSpacing ? {
            padding: '0 0 70px 0'
        } : {},
        children: [
            isShowHeader && /*#__PURE__*/ _jsxs("div", {
                className: styles.header,
                children: [
                    canBack && /*#__PURE__*/ _jsx(Button, {
                        type: "secondary",
                        icon: /*#__PURE__*/ _jsx(IconLeftArrow, {
                            fontSize: 16
                        }),
                        size: "small",
                        onClick: handleBackClick,
                        disabled: isBackDisabled
                    }),
                    (ui === null || ui === void 0 ? void 0 : ui.showClose) && /*#__PURE__*/ _jsx(Button, {
                        type: "secondary",
                        icon: /*#__PURE__*/ _jsx(IconClose, {
                            fontSize: 16
                        }),
                        size: "small",
                        onClick: handleCloseClick,
                        className: styles['close-btn']
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: classNames(styles.content, _define_property({}, styles['is-mobile'], isMobile)),
                children: renderContent()
            })
        ]
    });
}
function AuthContainer(props) {
    return /*#__PURE__*/ _jsx(I18nConsumer, {
        loaders: loginI18nLoaders,
        namespace: LOGIN_I18N_NAMESPACE,
        children: /*#__PURE__*/ _jsx(AuthContainerContent, _object_spread({}, props))
    });
}
export default AuthContainer;
